export default {
  confirmOrder: 'Confirmar pedido',
  createSuccess: 'Pedido criado com sucesso',
  orderPrice: 'Preço total do pedido',
  otherAction: 'Outras operações',
  orderStatus: 'Status do pedido',
  afterSales: 'Serviço pós-venda',
  allSelect: 'Selecionar todos',
  orderNo: 'Número do pedido',
  createTime: 'Hora de criação',
  productRemark: 'Informações de observação do produto',
  productRemarkHolder:
    'Mensagem para o comprador, se não houver requisitos especiais de compra, não preencha',
  orderDetail: 'Detalhes do pedido',
  goPay: 'Ir pagar',
  cancelpay: 'Cancelar pagamento',
  cancelPay: 'Cancelar pagamento?',
  cancelOrder: 'Cancelar pedido?',
  cancelorder: 'Cancelar pedido',
  cancelOrderProduct: 'Cancelar produto?',
  cancelorderProduct: 'Cancelar produto',
  cancelPayResultHint:
    'Após o cancelamento, o pagamento não pode ser restaurado, por favor, selecione o motivo do cancelamento do pagamento',
  cancelOrderResultHint:
    'Após o cancelamento, o pedido não pode ser restaurado, por favor, preencha o motivo do cancelamento do pedido',
  delOrder: 'Excluir pedido',
  delOrderHint:
    'Tem certeza de que deseja excluir o pedido? Se o produto já foi reembolsado, o produto não será devolvido ao vendedor para reembolso',
  cancelSuccess: 'Cancelado com sucesso',
  delSuccess: 'Excluído com sucesso',
  orderBin: 'Lixeira',
  backOrder: 'Voltar para meus pedidos',
  restoreOrder: 'Restaurar pedido',
  remark: 'Observações',
  all: 'Todos',
  productName: 'Nome do produto',
  submitTime: 'Hora de envio',
  orderConsult: 'Consulta de pedido',
  appendService: 'Serviço adicional',
  iKnow: 'Entendi',
  cancelReturnBag: 'Cancelar devolução/troca',
  isCancelApply: 'Tem certeza de que deseja cancelar a solicitação?',
  goPay2: 'Pagamento adicional',
  backTax: 'Pagamento adicional',
  cancelBackTax: 'Cancelar pagamento adicional',
  productAttr: 'Atributos do produto',
  backTaxType: 'Tipo de pagamento adicional',
  taxPrice: 'Preço do pagamento adicional',
  productBackTax: 'Pagamento adicional do produto',
  freightBackTax: 'Pagamento adicional do frete',
  productTaxPrice: 'Preço do pagamento adicional do produto',
  freightTaxPrice: 'Preço do pagamento adicional do frete',
  totalTaxPrice: 'Preço total do pagamento adicional',
  productStatus: 'Status do produto',
  isNeedTax: 'Precisa de pagamento adicional?',
  yes: 'Sim',
  no: 'Não',
  iThinkAbout: 'Vou pensar mais',
  revokeCheckedProduct: 'Revogar produto selecionado',
  taxTips1:
    'Por favor, [pague] ou [cancele] o mais rápido possível para evitar afetar a compra de outros produtos no pedido.',
  cancelTaxTips1:
    'Se você não quiser fazer o pagamento adicional, não poderemos comprar os produtos que precisam de pagamento adicional para você.',
  cancelTaxTips2:
    'Após a revogação, os produtos marcados serão cancelados e o custo do produto será reembolsado à sua conta.',
  cancelTaxTips3:
    'Os produtos não marcados continuarão sendo retidos e continuaremos comprando para você.',
  cancelReason: {
    0: 'Não quero mais comprar',
    1: 'Informações preenchidas incorretamente',
    2: 'Vendedor sem estoque',
    3: 'Não consigo pagar',
    4: 'Outros motivos',
    5: 'Risco de marca',
  },
  hint: 'Dica',
  orderStatusEnum: {
    0: 'Aguardando pagamento',
    1: 'Não processado',
    2: 'Em revisão',
    3: 'Pedido transferido',
    4: 'Cancelado',
    5: 'Pagamento adicional de frete',
    6: 'Revisão de controle de risco',
    7: 'Pedido cancelado',
    8: 'Em pagamento',
    9: 'Concluído',
  },
  returnGood: {
    name: 'Devolução/troca',
    selectType: 'Selecionar tipo',
    returnGood: 'Devolução',
    returnDayTips: 'Geralmente 7-15 dias',
    changeGood: 'Troca',
    changeDayTips: 'Geralmente 7-20 dias',
    returnReasonEnum: {
      0: 'Comprou errado/não gostou',
      1: 'Vendedor enviou produto errado?',
      2: 'Problema de qualidade do produto',
      3: 'Não enviou no prazo combinado',
      5: 'Outros motivos',
    },
    returnReasonSelect: 'Selecionar motivo da devolução',
    returnExplain: 'Descrição da devolução',
    residueReturnNumTips: 'Direito restante de devolução/troca sem taxa de serviço deste mês',
    returnTips:
      'Após verificação final, se o motivo da devolução for do vendedor ou da plataforma, o acbuy reembolsará o frete que você pagou.',
    changeTips:
      'Para devolução/troca causada pelo vendedor, você ainda pode precisar pagar parte do frete de troca.',
    returnTip4: 'Lembrete amigável',
    returnTip5:
      'O serviço de devolução/troca definirá o número de vezes de isenção de taxa de serviço de operação. (A primeira solicitação de devolução/troca de cada usuário por mês é isenta de taxa de serviço de operação. O frete gerado pela devolução/troca é negociado entre o agente e o vendedor e cobrado pelo acbuy. Taxa de serviço de devolução/troca do acbuy: 5 yuan/pedido)',
    returnTip10:
      'Se a responsabilidade da devolução/troca for do comprador/vendedor/plataforma, o sistema reembolsará esta taxa de operação de 5 yuan para sua conta de saldo acbuy.',
  },
  holder: {
    selectCancelReason: 'Por favor, selecione o motivo do cancelamento do pedido',
    inputOtherReason: 'Por favor, preencha o motivo',
    inputSearchHint: 'Nome/pedido principal/número do produto',
    inputCancelReason: 'Por favor, preencha o motivo do cancelamento do pedido',
  },
  selectProducts: 'Selecionar produtos',
  confirmStepOrder: 'Confirmar pedido',
  PayForProducts: 'Pagar produtos',
  sendingPackages: 'Enviar pacotes',
  submitDelivery: 'Enviar entrega',
  readAgreeText: 'Li e concordo',
  disclaimer: 'Aviso legal',
  orderNote:
    'Nota: Após o pagamento ser concluído, você precisará enviar o pacote para entrega internacional após o pacote chegar e ser armazenado no armazém.',
  reminder: 'Dica',
  disclaimer1: 'Descrição de itens proibidos',
  disclaimer2: 'Termos de serviço',
  disclaimer3: 'Política de devolução',
  customPhotosTips: 'Uma foto fornece apenas um requisito de detalhe para fotografar um produto',
  backCartEdit: 'Voltar para modificar carrinho',
  customPhotosReminderLabel: '   Lembrete amigável',
  customPhotosReminder:
    'Uma foto fornece apenas um requisito de detalhe para fotografar um produto',
  packageAgreeTip1:
    'Atrasos, danos, perdas, impostos, apreensões e outras incertezas relacionados aos serviços do provedor de logística estão fora do nosso controle, e não assumimos qualquer responsabilidade por isso. No entanto, faremos todos os esforços para lembrá-lo de pensar bem antes de comprar, ajudá-lo a resolver quaisquer problemas com fornecedores de logística e compensá-lo de acordo com a política pós-venda fornecida pelo fornecedor de logística.',
  packageAgreeTip2:
    'Recomendamos que você declare seu pacote com precisão. Se seu pacote for submetido a verificação aleatória durante a liberação alfandegária no país de destino, você pode precisar pagar alguns impostos. Se receber uma notificação fiscal, por favor, pague os impostos correspondentemente, caso contrário, você pode enfrentar consequências como pagamento de altas taxas de devolução e destruição do pacote.',
  applyRefund: 'Solicitar reembolso',
  refundReminder:
    'Lembrete amigável: Após solicitar o reembolso, o comprador verificará o status do produto. Antes da verificação ser concluída, não será possível cancelar a solicitação de reembolso.',
  inputApplyReason: 'Por favor, insira o motivo da solicitação',
  orderConfirm: 'Confirmar pedido',
  replyMsg: 'Responder mensagem',
  replyMsgTips:
    'As informações de observação que você enviar, notificaremos o comprador para verificar para você.',
  shoppingOrder: 'Pedido de compra',
  transportOrder: 'Pedido de reenvio',
  choosePlatform: 'Selecionar plataforma',
  selectTargetCountry: 'Selecionar país de destino',
  selectCountryTips:
    'Por favor, selecione/preencha seu país de destino para que o acbuy possa distinguir se os itens podem ser entregues.',
  pleaseSelectOrder: 'Por favor, selecione pedidos com a mesma moeda para pagamento',
  canNotStorageTip: 'Produtos armazenados há mais de 5 dias não podem solicitar devolução/troca',
  purchaseService: 'Serviço de compra',
  refundProgress: 'Reembolso em processamento',
  returnChangeTip:
    'Atenção: Problemas menores de qualidade do produto (marcas de cola, defeitos, manchas) o vendedor provavelmente não assumirá o frete de devolução/troca. Nesse caso, você precisará assumir esse frete!',
  goodNumTip:
    'Atenção: Quando a quantidade de compra do mesmo produto for maior ou igual a 10 peças, para melhorar a eficiência do armazenamento, o pessoal de inspeção de qualidade verificará apenas 20% dos seus produtos. No entanto, todas as cores, estilos e tamanhos dos produtos ainda serão verificados para você. Obrigado pela sua compreensão!',
  'i18n-0000001': 'Inspeção de qualidade em vídeo',
  'i18n-0000002': 'Introdução ao serviço',
  'i18n-0000003':
    'Filme um vídeo de produto de 20 - 90 segundos (a duração varia de acordo com o produto), fornecendo serviço de inspeção de qualidade em vídeo personalizado para usuários.',
  'i18n-0000004':
    'Atenção: Produtos eletrônicos digitais após serem ligados podem afetar o pós-venda, a plataforma não assume responsabilidade;',
  'i18n-0000005':
    'As rotas de logística para o país de destino selecionado são limitadas. Recomendamos que você use a ferramenta de estimativa de frete antes de fazer o pedido, ou adicione os produtos ao carrinho e use a função de estimativa de frete para estimar os custos de logística, evitando que o frete seja muito alto devido a restrições de rota.',
  'i18n-0000006': 'Rotas de entrega para país/região de destino: {lineNum}',
  buyAgain: 'Comprar novamente',
  remindShop: 'Apressar envio',
}
